import React, { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../states/userState";
import { Header } from "../components/layout/header/Header";
import Login from "../components/pages/login/Login";
import Footer from "../components/layout/header/Footer";
import Main from "../components/pages/main/Main";
import Page404 from "../components/pages/Page404";
import DndMain from "../components/pages/dnd/DndMain";
import Drafts from "../components/pages/drafts/Drafts";
import CardMain from "../components/pages/card/CardMain";

const Router: FC = () => {
  const user = useRecoilValue(userState);
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            user?.isAuth ? (
              <>
                <Header pageTitle={""} />
                <Main />
              </>
            ) : (
              <>
                {/* <Header pageTitle={""} /> */}
                <Login />
                {/* <Footer /> */}
              </>
            )
          }
        />

        <Route
          path="/drafts"
          element={
            user?.isAuth ? (
              <>
                <Header pageTitle={""} />
                <Drafts />
              </>
            ) : (
              <>
                <Header pageTitle={""} />
                <Login />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/dnd"
          element={
            user?.isAuth ? (
              <>
                <Header pageTitle={""} />
                <DndMain />
              </>
            ) : (
              <>
                <Header pageTitle={""} />
                <Login />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/card"
          element={
            user?.isAuth ? (
              <>
                <Header pageTitle={""} />
                <CardMain />
              </>
            ) : (
              <>
                <Header pageTitle={""} />
                <Login />
                <Footer />
              </>
            )
          }
        />
        {/* ICカード登録・変更 */}
        <Route
          path="/login"
          element={
            <>
              <Login />
            </>
          }
        />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
